// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.3_@rspack+core@1.7.6_webpack@5.99.9/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.3_@rspack+core@1.7.6_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.d-icon.d-data-type-icon {
  color: var(--primary-color);
  vertical-align: bottom; /* To keep the height of the .d-attribute-tile to the height set above (16px) */

  .dark-bg & {
    color: revert; /* Remove parent selector override and let global .dark-bg settings win */
  }

  & circle,
  & ellipse,
  & path,
  & rect {
    fill: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/cadenza/workbook/attribute-element/data-type-icon.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,sBAAsB,EAAE,+EAA+E;;EAEvG;IACE,aAAa,EAAE,yEAAyE;EAC1F;;EAEA;;;;IAIE,qBAAqB;EACvB;AACF","sourcesContent":[".d-icon.d-data-type-icon {\n  color: var(--primary-color);\n  vertical-align: bottom; /* To keep the height of the .d-attribute-tile to the height set above (16px) */\n\n  .dark-bg & {\n    color: revert; /* Remove parent selector override and let global .dark-bg settings win */\n  }\n\n  & circle,\n  & ellipse,\n  & path,\n  & rect {\n    fill: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
